module.exports = __webpack_public_path__ + "img/near2.3c3c749e.jpg";